const placeholder = 'Select an option';

$(document).ready(function() {
    $('.js-select').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        theme: 'custom',
        placeholder,
        templateSelection: function(data) {
            if (data.id === 'Placeholder') {
                return placeholder;
            } else {
                $(data.element)
                    .closest('.form__group')
                    .find('.select2-selection__rendered')
                    .addClass('active');
            }
            return data.text;
        }
    });

    // Add custom scroll
    $('select').on('select2:open', function(e) {
        $('.select2-results__options').mCustomScrollbar('destroy');
        setTimeout(function() {
            $('.select2-results__options').mCustomScrollbar();
        }, 10);
    });

    // Disable select2 search field
    $('select').on('select2:opening select2:closing', function(e) {
        const $searchfield = $(e.target).closest('.form__group').find('.select2-search__field');
        $searchfield.prop('disabled', true);
    });
});


// WEBPACK FOOTER //
// ./frontend/components/select/select.js